import * as profileRoutes from "./ProfileRoutes";
import AgencyContainer from "../modules/AgencyContainer";
import GroupContainter from "../modules/GroupContainter";
import InfotekContainer from "../modules/InfotekContainer";
import { ManagementContainer } from "../modules/Management/pages/ManagementContainer";
import ManagementContainer_old from "../modules/Management/pages/ManagementContainter_old";
import ProfileContainer from "../modules/ProfileContainer";
import TeamContainter from "../modules/TeamContainer";

export const ProfileRoutes = [
  {
    key: "profile",
    exact: true,
    path: profileRoutes.PROFILE,
    component: ProfileContainer,
  },
  {
    key: "management",
    exact: true,
    path: profileRoutes.MANAGEMENT,
    component: ManagementContainer,
  },
  {
    key: "management_old",
    exact: true,
    path: profileRoutes.MANAGEMENT_OLD,
    component: ManagementContainer_old,
  },
  {
    key: "group_management",
    exact: true,
    path: profileRoutes.GROUP,
    component: GroupContainter,
  },
  {
    key: "agency_management",
    exact: true,
    path: profileRoutes.AGENCY,
    component: AgencyContainer,
  },
  {
    key: "team_management",
    exact: true,
    path: profileRoutes.TEAM,
    component: TeamContainter,
  },
  // {
  //     key: "billing",
  //     exact: true,
  //     path: profileRoutes.BILLING,
  //     component: BillingContainer,
  // },
  // {
  //     key: "stats",
  //     exact: true,
  //     path: profileRoutes.STATS,
  //     component: StatsContainer,
  // },
  {
    key: "infotheque",
    exact: true,
    path: profileRoutes.INFOTHEQUE,
    component: InfotekContainer,
  },
  // {
  //     key: "offer",
  //     exact: true,
  //     path: profileRoutes.OFFER,
  //     component: OfferContainer,
  // },
];
